import React from "react";

export default function AcceptRejectBtnComponent({ onClick, icon }) {
    return (
        <div className="accept-reject-btn" onClick={onClick}>
            {icon}
        </div>
    );
}
